import Toast from "@/components/Ui/Toast.vue";
import ToastNotice from "@/components/Ui/ToastNotice.vue";
import { getToastPosition, useToastSafe } from "@/core/composable/useToast";
import { useAction } from "@/core/store/action";
import { useBus } from "@/core/store/bus";
import { Message } from "@/gql/gen";
import { defineStore } from "pinia";

export const useAlerts = defineStore("alerts", () => {
    const {bus} = useBus();
    const {runAction} = useAction();

    const onAlertClick = (message: Partial<Message>) => {
        const action = message.actions?.find((action) => true);
        if (action) {
            runAction(action);
        }
    };

    const showAlerts = (messages: Partial<Message>[]) => {
        const toast = useToastSafe();
        const POSITION = getToastPosition();

        if (!toast || !POSITION) return; // На сервере ничего не делаем

        for (const message of messages) {
            const cb = toast[message.type as keyof typeof toast];

            if (cb) {
                cb(
                    {
                        component: Toast,
                        props: {
                            title: message.title,
                            message: message.message,
                            messages: message.messages,
                            actions: message.actions,
                        },
                        listeners: {
                            click: () => onAlertClick(message),
                        },
                    },
                    {
                        position: POSITION.TOP_CENTER,
                        timeout: message.duration || 2000,
                    }
                );
            }
        }
    };

    const showAlert = (message: Partial<Message>) => {
        showAlerts([message]);
    };

    const showFlash = (message: Partial<Message>) => {
        showAlert({
            type: "info",
            ...message,
        });
    };

    const showNotices = (messages: Partial<Message>[]) => {
        const toast = useToastSafe();
        const POSITION = getToastPosition();

        if (!toast || !POSITION) return; // На сервере ничего не делаем

        for (const message of messages) {
            const cb = toast[message.type as keyof typeof toast];
            if (cb) {
                cb(
                    {
                        component: ToastNotice,
                        props: {
                            title: message.title,
                            message: message.message,
                            messages: message.messages,
                            actions: message.actions,
                            platform: 'ios',
                            appIcon: '/static/img/logo-s-white.png',
                            appName: 'SushiStudio'
                        },
                        listeners: {
                            click: () => onAlertClick(message),
                        },
                    },
                    {
                        position: POSITION.TOP_CENTER,
                        timeout: message.duration || 10000,
                        hideProgressBar: true,
                        closeButton: false,
                        icon: false,
                        toastClassName: "notice-toast",
                        bodyClassName: 'notice-toast__body',
                    }
                );
            }
        }
    };


    return {
        showAlerts,
        showAlert,
        showFlash,
        showNotices
    };
});
